import { render, staticRenderFns } from "./DataMRTidakAktif.vue?vue&type=template&id=1e87515c"
import script from "./DataMRTidakAktif.vue?vue&type=script&lang=js"
export * from "./DataMRTidakAktif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e87515c')) {
      api.createRecord('1e87515c', component.options)
    } else {
      api.reload('1e87515c', component.options)
    }
    module.hot.accept("./DataMRTidakAktif.vue?vue&type=template&id=1e87515c", function () {
      api.rerender('1e87515c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/retensi_dan_pemusnahan/DataMRTidakAktif.vue"
export default component.exports